export const diningOut = [
    {
      type: "restaurant",
      info: {
        resId: 19657198,
        name: "Tanatan",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/8/19657198/2310098025cbe62f00295c99f65da028_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/8/19657198/2310098025cbe62f00295c99f65da028_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/8/19657198/113814abd5edd521b3fe77c1965ddca3_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "3.9",
          rating_text: "3.9",
          rating_subtitle: "Good",
          rating_color: "9ACD32",
          votes: "223",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.0",
              reviewCount: "172",
              reviewTextSmall: "172 Reviews",
              subtext: "172 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.0",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "3.8",
              reviewCount: "51",
              reviewTextSmall: "51 Reviews",
              subtext: "51 Delivery Reviews",
              color: "#E23744",
              ratingV2: "3.8",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹1,000 for two",
        },
        cfo: {
          text: "₹500 for one",
        },
        locality: {
          name: "Hazratganj, Lucknow",
          address:
            "94, Ground & 1st Floor, Durga Bhawan, Mahatma Gandhi Marg, Mall Road, Hazratganj, Lucknow",
          localityUrl: "lucknow/hazratganj-restaurants",
        },
        timing: {
          text: "Closes in 59 minutes",
          color: "#e5521f",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzFcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/malwani/",
            name: "Malwani",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjkyXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/awadhi/",
            name: "Awadhi",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹1,000 for two",
        },
      },
      order: [],
      gold: [],
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/tanatan-hazratganj/info",
        clickActionDeeplink: "",
      },
      distance: "2.3 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19657198","element_type":"listing","rank":13}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 18560184,
        name: "The Terrace",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/4/18560184/8d923ed5ccb999ee0444edafa2c55d8e_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/4/18560184/8d923ed5ccb999ee0444edafa2c55d8e_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/4/18560184/b4a594a1e183105de417c256d73e5987_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.3",
          rating_text: "4.3",
          rating_subtitle: "Very Good",
          rating_color: "5BA829",
          votes: "1,004",
          subtext: "REVIEW",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.3",
              reviewCount: "1,004",
              reviewTextSmall: "1,004 Reviews",
              subtext: "1,004 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.3",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "",
              reviewCount: "0",
              reviewTextSmall: "0 Reviews",
              subtext: "Does not offer Delivery",
              color: "",
              ratingV2: "-",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "grey",
                tint: "500",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹1,400 for two",
        },
        cfo: {
          text: "₹500 for one",
        },
        locality: {
          name: "Hazratganj, Lucknow",
          address:
            "4th Floor, Hotel Charans Plaza, 11 Habibulah Estate, Hazratganj, Lucknow",
          localityUrl: "lucknow/hazratganj-restaurants",
        },
        timing: {
          text: "Closes in 59 minutes",
          color: "#e5521f",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/continental/",
            name: "Continental",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹1,400 for two",
        },
      },
      order: [],
      gold: [],
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/the-terrace-2-hazratganj/info",
        clickActionDeeplink: "",
      },
      distance: "1.6 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18560184","element_type":"listing","rank":14}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 800089,
        name: "Barbeque Nation",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/9/800089/4b5ab549625bf83b4d2c377881a93412_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/9/800089/4b5ab549625bf83b4d2c377881a93412_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/9/800089/6766f843bb4647810e2a7c5929cced1f_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.4",
          rating_text: "4.4",
          rating_subtitle: "Very Good",
          rating_color: "5BA829",
          votes: "3,261",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.9",
              reviewCount: "2,470",
              reviewTextSmall: "2,470 Reviews",
              subtext: "2,470 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.9",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "800",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "3.8",
              reviewCount: "791",
              reviewTextSmall: "791 Reviews",
              subtext: "791 Delivery Reviews",
              color: "#E23744",
              ratingV2: "3.8",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹1,600 for two",
        },
        cfo: {
          text: "₹500 for one",
        },
        locality: {
          name: "Riverside Mall, Gomti Nagar, Lucknow",
          address: "3rd Floor, Riverside Mall, Vipin Khand, Gomti Nagar, Lucknow",
          localityUrl: "lucknow/restaurants/in/riverside-mall-gomti-nagar",
        },
        timing: {
          text: "Opens tomorrow at 12noon",
          color: "#ab000d",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/chinese/",
            name: "Chinese",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/mediterranean/",
            name: "Mediterranean",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/desserts/",
            name: "Desserts",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/beverages/",
            name: "Beverages",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹1,600 for two",
        },
      },
      order: [],
      gold: [],
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/barbeque-nation-gomti-nagar/info",
        clickActionDeeplink: "",
      },
      distance: "2.5 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800089","element_type":"listing","rank":15}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [
        {
          type: "booking_cta",
          text: "Book a Table",
          clickUrl: "/lucknow/barbeque-nation-gomti-nagar/book",
        },
        {
          type: "chain_cta",
          text: "View all outlets",
          clickUrl: "/lucknow/restaurants/barbeque-nation?category=2",
        },
      ],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [
        {
          image: {
            url: "https://b.zmtcdn.com/MaxSafety/DiningBadge/a9e3f60f5ed05ff69a6bfa5eb87b442e1611745067.png",
            aspect_ratio: 2.66666666667,
          },
          text: "Follows all Max Safety measures ",
        },
      ],
    },
    {
      type: "restaurant",
      info: {
        resId: 19678663,
        name: "The Big Grill",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/3/19678663/0db33245c14222532d95f0e40bb6b156_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/3/19678663/0db33245c14222532d95f0e40bb6b156_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/3/19678663/9e2d8e66d3900de88a2217e6c73a4f11_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "3.9",
          rating_text: "NEW",
          rating_subtitle: "Good",
          rating_color: "9ACD32",
          votes: "77",
          subtext: "REVIEWS",
          is_new: true,
        },
        ratingNew: {
          newlyOpenedObj: {
            text: "Newly Opened",
            color: "#FFFFFF",
            bgColor: "#F4A266",
            bgColorV2: {
              type: "green",
              tint: "100",
            },
            subtitle: "OUTLET",
            ratingV2: "New",
          },
          suspiciousReviewObj: null,
          ratings: [],
        },
        cft: {
          text: "₹1,200 for two",
        },
        cfo: {
          text: "₹500 for one",
        },
        locality: {
          name: "Gomti Nagar, Lucknow",
          address: "Pheonix Palassio, Sector 7, Gomti Nagar, Lucknow",
          localityUrl: "lucknow/gomti-nagar-restaurants",
        },
        timing: {
          text: "Closes in 29 minutes",
          color: "#ab000d",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/chinese/",
            name: "Chinese",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/desserts/",
            name: "Desserts",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹1,200 for two",
        },
      },
      order: [],
      gold: [],
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/the-big-grill-gomti-nagar/info",
        clickActionDeeplink: "",
      },
      distance: "8.7 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19678663","element_type":"listing","rank":16}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 800969,
        name: "Bajpayee Kachodi Bhandar",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/9/800969/666de2d320ac84efd79e884f578cd31c_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/9/800969/666de2d320ac84efd79e884f578cd31c_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/9/800969/eb8b69113c4cc287284759252f20044c_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.2",
          rating_text: "4.2",
          rating_subtitle: "Very Good",
          rating_color: "5BA829",
          votes: "22K",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.3",
              reviewCount: "1,463",
              reviewTextSmall: "1,463 Reviews",
              subtext: "1,463 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.3",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "4.1",
              reviewCount: "20.5K",
              reviewTextSmall: "20.5K Reviews",
              subtext: "20.5K Delivery Reviews",
              color: "#E23744",
              ratingV2: "4.1",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹100 for two",
        },
        cfo: {
          text: "₹500 for one",
        },
        locality: {
          name: "Hazratganj, Lucknow",
          address:
            "Opposite Bank of India, Nawal Kishore Road, Hazratganj, Lucknow",
          localityUrl: "lucknow/hazratganj-restaurants",
        },
        timing: {
          text: "Opens tomorrow at 8am",
          color: "#ab000d",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/street-food/",
            name: "Street Food",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹100 for two",
        },
      },
      order: [],
      gold: [],
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/bajpayee-kachodi-bhandar-hazratganj/info",
        clickActionDeeplink: "",
      },
      distance: "1.7 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800969","element_type":"listing","rank":17}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 19021510,
        name: "The G.T. Road",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/0/19021510/095926533d3dd10cb44c48f238e7bb48_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/0/19021510/095926533d3dd10cb44c48f238e7bb48_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/0/19021510/aeceb71defba86e0945e1fa052d51b1e_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.0",
          rating_text: "4.0",
          rating_subtitle: "Very Good",
          rating_color: "5BA829",
          votes: "301",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.0",
              reviewCount: "301",
              reviewTextSmall: "301 Reviews",
              subtext: "301 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.0",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "",
              reviewCount: "0",
              reviewTextSmall: "0 Reviews",
              subtext: "Does not offer Delivery",
              color: "",
              ratingV2: "-",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "grey",
                tint: "500",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹1,000 for two",
        },
        cfo: {
          text: "₹500 for one",
        },
        locality: {
          name: "Gomti Nagar, Lucknow",
          address: "Rohtas Summit, TCG 3/3, Vibhuti Khand, Gomti Nagar, Lucknow",
          localityUrl: "lucknow/gomti-nagar-restaurants",
        },
        timing: {
          text: "Closes in 29 minutes",
          color: "#ab000d",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
            name: "Mughlai",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹1,000 for two",
        },
      },
      order: [],
      gold: {
        text: "Pro - Get 15% off",
      },
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/the-g-t-road-gomti-nagar/info",
        clickActionDeeplink: "",
      },
      distance: "6.2 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19021510","element_type":"listing","rank":18}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [
        {
          type: "booking_cta",
          text: "Book a Table",
          clickUrl: "/lucknow/the-g-t-road-gomti-nagar/book",
        },
      ],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [
        {
          image: {
            url: "https://b.zmtcdn.com/MaxSafety/DiningBadge/a9e3f60f5ed05ff69a6bfa5eb87b442e1611745067.png",
            aspect_ratio: 2.66666666667,
          },
          text: "Follows all Max Safety measures ",
        },
      ],
    },
    {
      type: "restaurant",
      info: {
        resId: 18639593,
        name: "The Flying Saucer Cafe",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/3/18639593/b44feccace075dc9567fa73fd3424e77_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/3/18639593/b44feccace075dc9567fa73fd3424e77_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/3/18639593/5d980eee2dd88ec1ba5a08e62f9dc82c_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.2",
          rating_text: "4.2",
          rating_subtitle: "Very Good",
          rating_color: "5BA829",
          votes: "1,386",
          subtext: "REVIEW",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.2",
              reviewCount: "1,002",
              reviewTextSmall: "1,002 Reviews",
              subtext: "1,002 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.2",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "4.1",
              reviewCount: "384",
              reviewTextSmall: "384 Reviews",
              subtext: "384 Delivery Reviews",
              color: "#E23744",
              ratingV2: "4.1",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹1,200 for two",
        },
        cfo: {
          text: "₹500 for one",
        },
        locality: {
          name: "Gomti Nagar, Lucknow",
          address:
            "14-18, Ground Floor, Rohtas Presidential Arcade, Vibhuti Khand, Gomti Nagar, Lucknow",
          localityUrl: "lucknow/gomti-nagar-restaurants",
        },
        timing: {
          text: "",
          color: "",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/cafes/",
            name: "Cafe",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/italian/",
            name: "Italian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/continental/",
            name: "Continental",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/chinese/",
            name: "Chinese",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹1,200 for two",
        },
      },
      order: [],
      gold: {
        text: "Pro - Get 20% off",
      },
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/the-flying-saucer-cafe-gomti-nagar/info",
        clickActionDeeplink: "",
      },
      distance: "5.7 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18639593","element_type":"listing","rank":19}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [
        {
          type: "booking_cta",
          text: "Book a Table",
          clickUrl: "/lucknow/the-flying-saucer-cafe-gomti-nagar/book",
        },
      ],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 18611147,
        name: "Bigg Daddy",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/7/18611147/dca25e7029d893a2dc9ef908befd4856_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/7/18611147/dca25e7029d893a2dc9ef908befd4856_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/7/18611147/ef18c53dad6ae9d821ad43fc46f6a8e7_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "3.9",
          rating_text: "3.9",
          rating_subtitle: "Good",
          rating_color: "9ACD32",
          votes: "1,932",
          subtext: "REVIEW",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.4",
              reviewCount: "1,842",
              reviewTextSmall: "1,842 Reviews",
              subtext: "1,842 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.4",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "3.4",
              reviewCount: "90",
              reviewTextSmall: "90 Reviews",
              subtext: "90 Delivery Reviews",
              color: "#E23744",
              ratingV2: "3.4",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "500",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹2,400 for two",
        },
        cfo: {
          text: "₹500 for one",
        },
        locality: {
          name: "Gomti Nagar, Lucknow",
          address:
            "6th Floor Balcony, Cyber Heights, Vibhuti Khand, Gomti Nagar, Lucknow",
          localityUrl: "lucknow/gomti-nagar-restaurants",
        },
        timing: {
          text: "Closes in 29 minutes",
          color: "#ab000d",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/street-food/",
            name: "Street Food",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/chinese/",
            name: "Chinese",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
            name: "Fast Food",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/beverages/",
            name: "Beverages",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/italian/",
            name: "Italian",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹2,400 for two",
        },
      },
      order: [],
      gold: {
        text: "Pro - Get 20% off",
      },
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/bigg-daddy-gomti-nagar/info",
        clickActionDeeplink: "",
      },
      distance: "5.7 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18611147","element_type":"listing","rank":20}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [
        {
          type: "booking_cta",
          text: "Book a Table",
          clickUrl: "/lucknow/bigg-daddy-gomti-nagar/book",
        },
      ],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 19288591,
        name: "Woodpecker",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/1/19288591/9bdee00da6a50f0dc400ad58f1a423b9_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/1/19288591/9bdee00da6a50f0dc400ad58f1a423b9_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: false,
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "3.9",
          rating_text: "3.9",
          rating_subtitle: "Good",
          rating_color: "9ACD32",
          votes: "128",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "3.9",
              reviewCount: "125",
              reviewTextSmall: "125 Reviews",
              subtext: "125 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "3.9",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "",
              reviewCount: "3",
              reviewTextSmall: "3 Reviews",
              subtext: "Does not offer Delivery",
              color: "",
              ratingV2: "-",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "grey",
                tint: "500",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹2,200 for two",
        },
        cfo: {
          text: "₹500 for one",
        },
        locality: {
          name: "Hazratganj, Lucknow",
          address:
            "Level Zero, Hotel Charans Plaza 11, Habibullah Estate, Hazratganj, Lucknow",
          localityUrl: "lucknow/hazratganj-restaurants",
        },
        timing: {
          text: "",
          color: "",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/desserts/",
            name: "Desserts",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/beverages/",
            name: "Beverages",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/pizza/",
            name: "Pizza",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹2,200 for two",
        },
      },
      order: [],
      gold: [],
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/woodpecker-hazratganj/info",
        clickActionDeeplink: "",
      },
      distance: "1.1 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19288591","element_type":"listing","rank":21}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [
        {
          type: "booking_cta",
          text: "Book a Table",
          clickUrl: "/lucknow/woodpecker-hazratganj/book",
        },
      ],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 800074,
        name: "Chhappan Bhog",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/4/800074/8a0789fe47d9eabc35643911a0015707_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/4/800074/8a0789fe47d9eabc35643911a0015707_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/4/800074/8f2b5fab05cf4d414861824ec39fcdf2_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.7",
          rating_text: "4.7",
          rating_subtitle: "Excellent",
          rating_color: "3F7E00",
          votes: "929",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.7",
              reviewCount: "929",
              reviewTextSmall: "929 Reviews",
              subtext: "929 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.7",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "800",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "",
              reviewCount: "0",
              reviewTextSmall: "0 Reviews",
              subtext: "Does not offer Delivery",
              color: "",
              ratingV2: "-",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "grey",
                tint: "500",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹300 for two",
        },
        cfo: {
          text: "₹500 for one",
        },
        locality: {
          name: "Sadar Bazaar, Lucknow",
          address: "Apna Bazaar, Sadar Bazaar, Lucknow",
          localityUrl: "lucknow/sadar-bazaar-restaurants",
        },
        timing: {
          text: "Opens tomorrow at 8:30am",
          color: "#ab000d",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAxNVwiXX0iXQ%3D%3D",
            url: "https://www.zomato.com/lucknow/restaurants/mithai/",
            name: "Mithai",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/street-food/",
            name: "Street Food",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹300 for two",
        },
      },
      order: [],
      gold: [],
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/chhappan-bhog-sadar-bazaar/info",
        clickActionDeeplink: "",
      },
      distance: "4.1 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800074","element_type":"listing","rank":22}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 801269,
        name: "Vintage Machine",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/9/801269/cebfdb033a0a31eceb4e4f2ad54af68a_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/9/801269/cebfdb033a0a31eceb4e4f2ad54af68a_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/9/801269/5269e32712d2c2d0a49fe3a336df8117_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.5",
          rating_text: "4.5",
          rating_subtitle: "Excellent",
          rating_color: "3F7E00",
          votes: "2,673",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.5",
              reviewCount: "1,756",
              reviewTextSmall: "1,756 Reviews",
              subtext: "1,756 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.5",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "4.4",
              reviewCount: "917",
              reviewTextSmall: "917 Reviews",
              subtext: "917 Delivery Reviews",
              color: "#E23744",
              ratingV2: "4.4",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹1,000 for two",
        },
        cfo: {
          text: "₹500 for one",
        },
        locality: {
          name: "Gomti Nagar, Lucknow",
          address: "3/11, Patrakar Puram, Gomti Nagar, Lucknow",
          localityUrl: "lucknow/gomti-nagar-restaurants",
        },
        timing: {
          text: "Closes in 29 minutes",
          color: "#ab000d",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/cafes/",
            name: "Cafe",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMVwiXX0iXQ%3D%3D",
            url: "https://www.zomato.com/lucknow/restaurants/american/",
            name: "American",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/italian/",
            name: "Italian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNjZcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/lebanese/",
            name: "Lebanese",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹1,000 for two",
        },
      },
      order: [],
      gold: [],
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/vintage-machine-gomti-nagar/info",
        clickActionDeeplink: "",
      },
      distance: "5.1 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"801269","element_type":"listing","rank":23}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 18971277,
        name: "Cafe Repertwahr",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/7/18971277/a7523dfa26a7d79b13f597470068695d_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/7/18971277/a7523dfa26a7d79b13f597470068695d_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/7/18971277/01e680560b6e18cdd61b77c2188fccdf_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.0",
          rating_text: "4.0",
          rating_subtitle: "Very Good",
          rating_color: "5BA829",
          votes: "1,994",
          subtext: "REVIEW",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.3",
              reviewCount: "673",
              reviewTextSmall: "673 Reviews",
              subtext: "673 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.3",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "3.6",
              reviewCount: "1,321",
              reviewTextSmall: "1,321 Reviews",
              subtext: "1,321 Delivery Reviews",
              color: "#E23744",
              ratingV2: "3.6",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹800 for two",
        },
        cfo: {
          text: "₹500 for one",
        },
        locality: {
          name: "Indira Nagar, Lucknow",
          address:
            "A2, 3rd Floor, Kala Niketan, Faizabad Road, Maruti Puram, Indira Nagar, Lucknow",
          localityUrl: "lucknow/indira-nagar-restaurants",
        },
        timing: {
          text: "Opens tomorrow at 12noon",
          color: "#ab000d",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/pizza/",
            name: "Pizza",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/chinese/",
            name: "Chinese",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/continental/",
            name: "Continental",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/italian/",
            name: "Italian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODNcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/sea-food/",
            name: "Seafood",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTk4XCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/salad/",
            name: "Salad",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹800 for two",
        },
      },
      order: [],
      gold: {
        text: "Pro - Get 20% off",
      },
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/cafe-repertwahr-indira-nagar/info",
        clickActionDeeplink: "",
      },
      distance: "2.6 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18971277","element_type":"listing","rank":24}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [
        {
          type: "booking_cta",
          text: "Book a Table",
          clickUrl: "/lucknow/cafe-repertwahr-indira-nagar/book",
        },
      ],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [
        {
          image: {
            url: "https://b.zmtcdn.com/MaxSafety/DiningBadge/a9e3f60f5ed05ff69a6bfa5eb87b442e1611745067.png",
            aspect_ratio: 2.66666666667,
          },
          text: "Follows all Max Safety measures ",
        },
      ],
    },
  
    {
      type: "restaurant",
      info: {
        resId: 800120,
        name: "Royal Cafe - Royal Inn",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/0/800120/2911d7005a27e8fd3dd1352f55e3221f_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/0/800120/2911d7005a27e8fd3dd1352f55e3221f_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/0/800120/4ca9ece7dc363c9f0bf04baece6b3d9f_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.2",
          rating_text: "4.2",
          rating_subtitle: "Very Good",
          rating_color: "5BA829",
          votes: "6,312",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.3",
              reviewCount: "847",
              reviewTextSmall: "847 Reviews",
              subtext: "847 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.3",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "4.0",
              reviewCount: "5,465",
              reviewTextSmall: "5,465 Reviews",
              subtext: "5,465 Delivery Reviews",
              color: "#E23744",
              ratingV2: "4.0",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹500 for two",
        },
        cfo: {
          text: "₹350 for one",
        },
        locality: {
          name: "Royal Inn, Hazratganj, Lucknow",
          address:
            "9/7, Royal Inn, Shahnajaf Road, Opposite Sahara Ganj Mall, Hazratganj, Lucknow",
          localityUrl: "lucknow/restaurants/in/royal-inn-hazratganj",
        },
        timing: {
          text: "",
          color: "",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
            url: "https://www.zomato.com/lucknow/restaurants/biryani/",
            name: "Biryani",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
            name: "Mughlai",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/pizza/",
            name: "Pizza",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
            name: "Fast Food",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/beverages/",
            name: "Beverages",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹500 for two",
        },
      },
      order: [],
      gold: {
        text: "Pro - Get 20% off",
      },
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/royal-cafe-royal-inn-hazratganj/info",
        clickActionDeeplink: "",
      },
      distance: "989 m",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800120","element_type":"listing","rank":25}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [
        {
          type: "chain_cta",
          text: "View all outlets",
          clickUrl: "/lucknow/restaurants/royal-cafe-royal-inn?category=2",
        },
      ],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 800326,
        name: "Royal Sky",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/6/800326/58780939ee98196021a081d74b7266ec_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/6/800326/58780939ee98196021a081d74b7266ec_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/6/800326/9713d1a53bbf9459d1007f7cdc61cba3_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.3",
          rating_text: "4.3",
          rating_subtitle: "Very Good",
          rating_color: "5BA829",
          votes: "3,473",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.4",
              reviewCount: "1,690",
              reviewTextSmall: "1,690 Reviews",
              subtext: "1,690 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.4",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "4.1",
              reviewCount: "1,783",
              reviewTextSmall: "1,783 Reviews",
              subtext: "1,783 Delivery Reviews",
              color: "#E23744",
              ratingV2: "4.1",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹1,100 for two",
        },
        cfo: {
          text: "₹350 for one",
        },
        locality: {
          name: "Hazratganj, Lucknow",
          address:
            "31/039, GF - 3 (31/37), Mahatma Gandhi Marg, Hazratganj, Lucknow",
          localityUrl: "lucknow/hazratganj-restaurants",
        },
        timing: {
          text: "Closes in 29 minutes",
          color: "#ab000d",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
            name: "Mughlai",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/chinese/",
            name: "Chinese",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/continental/",
            name: "Continental",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹1,100 for two",
        },
      },
      order: [],
      gold: {
        text: "Pro - Get 20% off",
      },
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/royal-sky-1-hazratganj/info",
        clickActionDeeplink: "",
      },
      distance: "1.8 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"800326","element_type":"listing","rank":26}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 18576127,
        name: "Zync Bar & Lounge",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/7/18576127/43918fc88e5ec3106d710d164e1f54d1_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/7/18576127/43918fc88e5ec3106d710d164e1f54d1_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/7/18576127/e565a7d4d7f74824193119287a9ac47f_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.0",
          rating_text: "4.0",
          rating_subtitle: "Very Good",
          rating_color: "5BA829",
          votes: "509",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.1",
              reviewCount: "341",
              reviewTextSmall: "341 Reviews",
              subtext: "341 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.1",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "3.9",
              reviewCount: "168",
              reviewTextSmall: "168 Reviews",
              subtext: "168 Delivery Reviews",
              color: "#E23744",
              ratingV2: "3.9",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹600 for two",
        },
        cfo: {
          text: "₹350 for one",
        },
        locality: {
          name: "Gomti Nagar, Lucknow",
          address: "Cyber Height Vibhuti Khand, Gomti Nagar, Lucknow",
          localityUrl: "lucknow/gomti-nagar-restaurants",
        },
        timing: {
          text: "Closes in 1 hour 28 minutes",
          color: "#e5521f",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/chinese/",
            name: "Chinese",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/mughlai/",
            name: "Mughlai",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjkyXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/awadhi/",
            name: "Awadhi",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹600 for two",
        },
      },
      order: [],
      gold: {
        text: "Pro - Get 25% off",
      },
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/zync-bar-lounge-gomti-nagar/info",
        clickActionDeeplink: "",
      },
      distance: "6 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18576127","element_type":"listing","rank":27}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [
        {
          type: "booking_cta",
          text: "Book a Table",
          clickUrl: "/lucknow/zync-bar-lounge-gomti-nagar/book",
        },
      ],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [
        {
          image: {
            url: "https://b.zmtcdn.com/MaxSafety/DiningBadge/a9e3f60f5ed05ff69a6bfa5eb87b442e1611745067.png",
            aspect_ratio: 2.66666666667,
          },
          text: "Follows all Max Safety measures ",
        },
      ],
    },
    {
      type: "restaurant",
      info: {
        resId: 18660085,
        name: "Munick Bistro & Bar",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/5/18660085/af34bf15a659b46f729589584dcf378e_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/5/18660085/af34bf15a659b46f729589584dcf378e_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/5/18660085/9f765871c689d14b62d30a117655458b_o2_featured_v2.jpeg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "3.9",
          rating_text: "3.9",
          rating_subtitle: "Good",
          rating_color: "9ACD32",
          votes: "1,407",
          subtext: "REVIEW",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.4",
              reviewCount: "1,148",
              reviewTextSmall: "1,148 Reviews",
              subtext: "1,148 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.4",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "3.3",
              reviewCount: "259",
              reviewTextSmall: "259 Reviews",
              subtext: "259 Delivery Reviews",
              color: "#E23744",
              ratingV2: "3.3",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "500",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹1,200 for two",
        },
        cfo: {
          text: "₹350 for one",
        },
        locality: {
          name: "Gomti Nagar, Lucknow",
          address:
            "27 & 31, Rohtash Presidential Arcade, Vibhuti Khand, Gomti Nagar, Lucknow",
          localityUrl: "lucknow/gomti-nagar-restaurants",
        },
        timing: {
          text: "Closes in 29 minutes",
          color: "#ab000d",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/chinese/",
            name: "Chinese",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/continental/",
            name: "Continental",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzhcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/european/",
            name: "European",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTM0XCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/german/",
            name: "German",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/italian/",
            name: "Italian",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹1,200 for two",
        },
      },
      order: [],
      gold: {
        text: "Pro - Get 30% off",
      },
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/munick-bistro-bar-gomti-nagar/info",
        clickActionDeeplink: "",
      },
      distance: "5.8 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18660085","element_type":"listing","rank":28}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [
        {
          type: "booking_cta",
          text: "Book a Table",
          clickUrl: "/lucknow/munick-bistro-bar-gomti-nagar/book",
        },
      ],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 19642697,
        name: "Firefly",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/7/19642697/ae328d5ca49ac1490a672bcc2a9b0cec_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/7/19642697/ae328d5ca49ac1490a672bcc2a9b0cec_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: false,
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "3.0",
          rating_text: "3.0",
          rating_subtitle: "Average",
          rating_color: "CDD614",
          votes: "21",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "3.0",
              reviewCount: "21",
              reviewTextSmall: "21 Reviews",
              subtext: "21 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "3.0",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "yellow",
                tint: "600",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "",
              reviewCount: "0",
              reviewTextSmall: "0 Reviews",
              subtext: "Does not offer Delivery",
              color: "",
              ratingV2: "-",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "grey",
                tint: "500",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹1,200 for two",
        },
        cfo: {
          text: "₹350 for one",
        },
        locality: {
          name: "Gomti Nagar, Lucknow",
          address:
            "15th Floor, Summit Building, TCG 3, Vibhuti Khand, Gomti Nagar, Lucknow",
          localityUrl: "lucknow/gomti-nagar-restaurants",
        },
        timing: {
          text: "Closes in 1 hour 28 minutes",
          color: "#e5521f",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/south-indian/",
            name: "South Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/chinese/",
            name: "Chinese",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/italian/",
            name: "Italian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/thai/",
            name: "Thai",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNjBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/japanese/",
            name: "Japanese",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹1,200 for two",
        },
      },
      order: [],
      gold: {
        text: "Pro - Get 20% off",
      },
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/firefly-gomti-nagar/info",
        clickActionDeeplink: "",
      },
      distance: "6.1 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19642697","element_type":"listing","rank":29}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 19425565,
        name: "Goku",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/5/19425565/df53811bb9fc328d3d118e3a1e7df129_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/5/19425565/df53811bb9fc328d3d118e3a1e7df129_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/5/19425565/7f6319194a8d6417d2338e4407f829d2_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "3.8",
          rating_text: "3.8",
          rating_subtitle: "Good",
          rating_color: "9ACD32",
          votes: "333",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "3.9",
              reviewCount: "100",
              reviewTextSmall: "100 Reviews",
              subtext: "100 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "3.9",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "3.7",
              reviewCount: "233",
              reviewTextSmall: "233 Reviews",
              subtext: "233 Delivery Reviews",
              color: "#E23744",
              ratingV2: "3.7",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹1,200 for two",
        },
        cfo: {
          text: "₹350 for one",
        },
        locality: {
          name: "Gomti Nagar, Lucknow",
          address: "Shop 1/120, Deva Palace, Patrakarpuram, Gomti Nagar, Lucknow",
          localityUrl: "lucknow/gomti-nagar-restaurants",
        },
        timing: {
          text: "Closes in 29 minutes",
          color: "#ab000d",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNjBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/japanese/",
            name: "Japanese",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/thai/",
            name: "Thai",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNjdcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/korean/",
            name: "Korean",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹1,200 for two",
        },
      },
      order: [],
      gold: {
        text: "Pro - Get 20% off",
      },
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/goku-gomti-nagar/info",
        clickActionDeeplink: "",
      },
      distance: "5.7 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19425565","element_type":"listing","rank":30}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 19612752,
        name: "Vintage Machine - Kitchen + Cocktail Bar",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/2/19612752/aafed1313d00f68fced26dbf5b97ce58_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/2/19612752/aafed1313d00f68fced26dbf5b97ce58_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/2/19612752/81b74725febb4a2b1a709e47ff624b21_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "3.8",
          rating_text: "3.8",
          rating_subtitle: "Good",
          rating_color: "9ACD32",
          votes: "56",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "3.8",
              reviewCount: "56",
              reviewTextSmall: "56 Reviews",
              subtext: "56 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "3.8",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "",
              reviewCount: "0",
              reviewTextSmall: "0 Reviews",
              subtext: "Does not offer Delivery",
              color: "",
              ratingV2: "-",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "grey",
                tint: "500",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹1,000 for two",
        },
        cfo: {
          text: "₹350 for one",
        },
        locality: {
          name: "Gomti Nagar, Lucknow",
          address:
            "Ground Floor, Rohtas Summit, Vibhuti Khand, Gomti Nagar, Lucknow",
          localityUrl: "lucknow/gomti-nagar-restaurants",
        },
        timing: {
          text: "Closes in 1 hour 28 minutes",
          color: "#e5521f",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/italian/",
            name: "Italian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
            url: "https://www.zomato.com/lucknow/restaurants/asian/",
            name: "Asian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/chinese/",
            name: "Chinese",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNzNcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/mexican/",
            name: "Mexican",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/continental/",
            name: "Continental",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/beverages/",
            name: "Beverages",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹1,000 for two",
        },
      },
      order: [],
      gold: [],
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl:
          "/lucknow/vintage-machine-kitchen-cocktail-bar-gomti-nagar/info",
        clickActionDeeplink: "",
      },
      distance: "6.2 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19612752","element_type":"listing","rank":31}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [
        {
          type: "booking_cta",
          text: "Book a Table",
          clickUrl:
            "/lucknow/vintage-machine-kitchen-cocktail-bar-gomti-nagar/book",
        },
      ],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 18439027,
        name: "Skyhilton",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/7/18439027/d05be9594f3a4208b0947d86da5cd275_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/7/18439027/d05be9594f3a4208b0947d86da5cd275_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/7/18439027/8a4517cb0ad08138a07d47f494cad7f1_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.2",
          rating_text: "4.2",
          rating_subtitle: "Very Good",
          rating_color: "5BA829",
          votes: "2,822",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.4",
              reviewCount: "1,612",
              reviewTextSmall: "1,612 Reviews",
              subtext: "1,612 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.4",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "4.0",
              reviewCount: "1,210",
              reviewTextSmall: "1,210 Reviews",
              subtext: "1,210 Delivery Reviews",
              color: "#E23744",
              ratingV2: "4.0",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹1,500 for two",
        },
        cfo: {
          text: "₹350 for one",
        },
        locality: {
          name: "Alambagh, Lucknow",
          address:
            "5th floor, J.B Emporer Square,1212 SA Bargawan, Alambagh, Lucknow",
          localityUrl: "lucknow/alambagh-restaurants",
        },
        timing: {
          text: "Closes in 1 hour 28 minutes",
          color: "#e5521f",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/chinese/",
            name: "Chinese",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/continental/",
            name: "Continental",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
            name: "Fast Food",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/desserts/",
            name: "Desserts",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/beverages/",
            name: "Beverages",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹1,500 for two",
        },
      },
      order: [],
      gold: {
        text: "Pro - Get 20% off",
      },
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/skyhilton-1-alambagh/info",
        clickActionDeeplink: "",
      },
      distance: "8.7 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18439027","element_type":"listing","rank":32}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [
        {
          type: "booking_cta",
          text: "Book a Table",
          clickUrl: "/lucknow/skyhilton-1-alambagh/book",
        },
      ],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 19415265,
        name: "Home Sweet Home",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/5/19415265/359aee412596fe7259a491fe460beb91_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/5/19415265/359aee412596fe7259a491fe460beb91_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/5/19415265/242d85aa14666955b78fd407238536af_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "3.9",
          rating_text: "3.9",
          rating_subtitle: "Good",
          rating_color: "9ACD32",
          votes: "319",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.0",
              reviewCount: "116",
              reviewTextSmall: "116 Reviews",
              subtext: "116 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.0",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "3.7",
              reviewCount: "203",
              reviewTextSmall: "203 Reviews",
              subtext: "203 Delivery Reviews",
              color: "#E23744",
              ratingV2: "3.7",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹700 for two",
        },
        cfo: {
          text: "₹350 for one",
        },
        locality: {
          name: "Hazratganj, Lucknow",
          address:
            "House 11, 3rd Floor, Halwasiya, M.G. Road, Hazratganj, Lucknow",
          localityUrl: "lucknow/hazratganj-restaurants",
        },
        timing: {
          text: "Closes in 29 minutes",
          color: "#ab000d",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/pizza/",
            name: "Pizza",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMzVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/continental/",
            name: "Continental",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiM1wiXX0iXQ%3D%3D",
            url: "https://www.zomato.com/lucknow/restaurants/asian/",
            name: "Asian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiN1wiXX0iXQ%3D%3D",
            url: "https://www.zomato.com/lucknow/restaurants/biryani/",
            name: "Biryani",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/beverages/",
            name: "Beverages",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹700 for two",
        },
      },
      order: [],
      gold: [],
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/home-sweet-home-hazratganj/info",
        clickActionDeeplink: "",
      },
      distance: "1.7 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19415265","element_type":"listing","rank":33}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [
        {
          image: {
            url: "https://b.zmtcdn.com/MaxSafety/DiningBadge/a9e3f60f5ed05ff69a6bfa5eb87b442e1611745067.png",
            aspect_ratio: 2.66666666667,
          },
          text: "Follows all Max Safety measures ",
        },
      ],
    },
    {
      type: "restaurant",
      info: {
        resId: 18591136,
        name: "The Urban Dhaba",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/6/18591136/871b8d0d6a8ceb82b5c1bcd94a12ddbf_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/6/18591136/871b8d0d6a8ceb82b5c1bcd94a12ddbf_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/6/18591136/8c8155b66f0dd25d97f426d9acc428d4_o2_featured_v2.jpg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.0",
          rating_text: "4.0",
          rating_subtitle: "Very Good",
          rating_color: "5BA829",
          votes: "4,669",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.3",
              reviewCount: "1,329",
              reviewTextSmall: "1,329 Reviews",
              subtext: "1,329 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.3",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "3.7",
              reviewCount: "3,340",
              reviewTextSmall: "3,340 Reviews",
              subtext: "3,340 Delivery Reviews",
              color: "#E23744",
              ratingV2: "3.7",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹850 for two",
        },
        cfo: {
          text: "₹350 for one",
        },
        locality: {
          name: "Gomti Nagar, Lucknow",
          address:
            "3/187 Vivek Khand, Gomti Nagar Above Spencer's, Gomti Nagar, Lucknow",
          localityUrl: "lucknow/gomti-nagar-restaurants",
        },
        timing: {
          text: "Closes in 29 minutes",
          color: "#ab000d",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹850 for two",
        },
      },
      order: [],
      gold: {
        text: "Pro - Get 25% off",
      },
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/the-urban-dhaba-gomti-nagar/info",
        clickActionDeeplink: "",
      },
      distance: "4.8 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18591136","element_type":"listing","rank":34}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [
        {
          type: "booking_cta",
          text: "Book a Table",
          clickUrl: "/lucknow/the-urban-dhaba-gomti-nagar/book",
        },
      ],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 18970077,
        name: "The Hazelnut Factory",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/7/18970077/19544c25ff84152250d8a1bbf5bf3be6_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/7/18970077/19544c25ff84152250d8a1bbf5bf3be6_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/7/18970077/21686b862df983224b771b4a405bc664_o2_featured_v2.jpeg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.5",
          rating_text: "4.5",
          rating_subtitle: "Excellent",
          rating_color: "3F7E00",
          votes: "15.6K",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.5",
              reviewCount: "747",
              reviewTextSmall: "747 Reviews",
              subtext: "747 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.5",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "4.4",
              reviewCount: "14.8K",
              reviewTextSmall: "14.8K Reviews",
              subtext: "14.8K Delivery Reviews",
              color: "#E23744",
              ratingV2: "4.4",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "green",
                tint: "700",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹400 for two",
        },
        cfo: {
          text: "₹350 for one",
        },
        locality: {
          name: "Nirala Nagar, Lucknow",
          address: "B-192, Rama Krishna Math, Nirala Nagar, Lucknow",
          localityUrl: "lucknow/nirala-nagar-restaurants",
        },
        timing: {
          text: "Closes in 29 minutes",
          color: "#ab000d",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNVwiXX0iXQ%3D%3D",
            url: "https://www.zomato.com/lucknow/restaurants/bakery/",
            name: "Bakery",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAxNVwiXX0iXQ%3D%3D",
            url: "https://www.zomato.com/lucknow/restaurants/mithai/",
            name: "Mithai",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNDBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/fast-food/",
            name: "Fast Food",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiOTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/street-food/",
            name: "Street Food",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/pizza/",
            name: "Pizza",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMTAwXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/desserts/",
            name: "Desserts",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/beverages/",
            name: "Beverages",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹400 for two",
        },
      },
      order: [],
      gold: [],
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/the-hazelnut-factory-nirala-nagar/info",
        clickActionDeeplink: "",
      },
      distance: "1.4 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"18970077","element_type":"listing","rank":35}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [
        {
          type: "chain_cta",
          text: "View all outlets",
          clickUrl: "/lucknow/restaurants/the-hazelnut-factory?category=2",
        },
      ],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [],
    },
    {
      type: "restaurant",
      info: {
        resId: 19463530,
        name: "The Beer Cafe Biggie",
        image: {
          url: "https://b.zmtcdn.com/data/pictures/0/19463530/575a8965aeb1ff7d1b926438eee25830_featured_v2.jpg",
          urlWithParams:
            "https://b.zmtcdn.com/data/pictures/0/19463530/575a8965aeb1ff7d1b926438eee25830_featured_v2.jpg?fit=around%7C108%3A108&crop=108%3A108%3B%2A%2C%2A",
        },
        o2FeaturedImage: {
          url: "https://b.zmtcdn.com/data/pictures/0/19463530/607835b4835149b4c2cb544b5420b9eb_o2_featured_v2.jpeg",
        },
        rating: {
          has_fake_reviews: 0,
          aggregate_rating: "4.0",
          rating_text: "4.0",
          rating_subtitle: "Very Good",
          rating_color: "5BA829",
          votes: "126",
          subtext: "REVIEWS",
          is_new: false,
        },
        ratingNew: {
          newlyOpenedObj: null,
          suspiciousReviewObj: null,
          ratings: {
            DINING: {
              rating_type: "DINING",
              rating: "4.0",
              reviewCount: "125",
              reviewTextSmall: "125 Reviews",
              subtext: "125 Dining Reviews",
              color: "#1C1C1C",
              ratingV2: "4.0",
              subtitle: "DINING",
              sideSubTitle: "Dining Reviews",
              bgColorV2: {
                type: "green",
                tint: "600",
              },
            },
            DELIVERY: {
              rating_type: "DELIVERY",
              rating: "",
              reviewCount: "1",
              reviewTextSmall: "1 Reviews",
              subtext: "Does not offer Delivery",
              color: "",
              ratingV2: "-",
              subtitle: "DELIVERY",
              sideSubTitle: "Delivery Reviews",
              bgColorV2: {
                type: "grey",
                tint: "500",
              },
              newOnDelivery: false,
            },
          },
        },
        cft: {
          text: "₹1,700 for two",
        },
        cfo: {
          text: "₹350 for one",
        },
        locality: {
          name: "Hazratganj, Lucknow",
          address:
            "Second Floor, Rohit House, Shahnajaf Road, Opposite Sahara Mall, Hazratganj, Lucknow",
          localityUrl: "lucknow/hazratganj-restaurants",
        },
        timing: {
          text: "Closes in 1 hour 28 minutes",
          color: "#e5521f",
        },
        cuisine: [
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/italian/",
            name: "Italian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiODJcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/pizza/",
            name: "Pizza",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjVcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/chinese/",
            name: "Chinese",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNTBcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/north-indian/",
            name: "North Indian",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiNjZcIl19Il0%3D",
            url: "https://www.zomato.com/lucknow/restaurants/lebanese/",
            name: "Lebanese",
          },
          {
            deeplink:
              "zomato://search?deeplink_filters=WyJ7XCJjb250ZXh0XCI6XCJhbGxcIn0iLCJ7XCJjdWlzaW5lX2lkXCI6W1wiMjcwXCJdfSJd",
            url: "https://www.zomato.com/lucknow/restaurants/beverages/",
            name: "Beverages",
          },
        ],
        should_ban_ugc: false,
        costText: {
          text: "₹1,700 for two",
        },
      },
      order: [],
      gold: {
        text: "Pro - Get 20% off",
      },
      takeaway: [],
      cardAction: {
        text: "",
        clickUrl: "/lucknow/the-beer-cafe-biggie-hazratganj/info",
        clickActionDeeplink: "",
      },
      distance: "1.1 km",
      isPromoted: false,
      promotedText: "",
      trackingData: [
        {
          table_name: "zsearch_events_log",
          payload:
            '{"search_id":"c2c9e9d0-0572-42fa-8cc0-16eeebb240cb","location_type":"delivery_cell","location_id":"4151190155136335872","page_type":"dineout","app_type":"new_web_consumer","section":"restaurants","entity_type":"restaurant","entity_id":"19463530","element_type":"listing","rank":36}',
          event_names: {
            tap: '{"action":"tap"}',
            impression: '{"action":"impression"}',
          },
        },
      ],
      allCTA: [
        {
          type: "booking_cta",
          text: "Book a Table",
          clickUrl: "/lucknow/the-beer-cafe-biggie-hazratganj/book",
        },
      ],
      promoOffer: "",
      checkBulkOffers: false,
      bulkOffers: [],
      isDisabled: false,
      bottomContainers: [
        {
          image: {
            url: "https://b.zmtcdn.com/MaxSafety/DiningBadge/a9e3f60f5ed05ff69a6bfa5eb87b442e1611745067.png",
            aspect_ratio: 2.66666666667,
          },
          text: "Follows all Max Safety measures ",
        },
      ],
    },
  ];